// src/components/ProductList.tsx
import React, { useState, useEffect } from 'react';
import { Button, Badge, Alert, Row, Col } from 'react-bootstrap';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import DowngradeConfirmationModal  from './DowngradeConfirmationModal.js';

const ProductList: React.FC<ProductListProps> = () => {
  const { canvaAuthenticated, setCanvaAuthenticated,token } = useCanvaAuth();
  const userProfile=canvaAuthenticated.userProfile;
  const env=canvaAuthenticated.env;
  const [isLoading, setIsLoading] = useState(false);
  const [error,setError] = useState(false);
  const [downgradeFlyout, setDowngradeFlyout] = useState<any>(false);

	const productNames = [
    { tier: '1.00', name: "AI Music Free"},
    	{ tier: '1.90', name: "AI Music PayOnce" },
    { tier: '2.00', name: "AI Music Basic" },
    { tier: '3.00', name: "AI Music Premium" },
    // Add more alerts here
];

const featureDescriptions = [
    { id: 1, featureKey: "1000_tokens", stringKey: 'product-feature-1000_tokens-description', category: "tokens", description: "1000 tokens monthly" },
    { id: 2, featureKey: "3000_tokens", stringKey: 'product-feature-3000_tokens-description', category: "tokens", description: "3000 tokens monthly" },
    { id: 3, featureKey: "10000_tokens", stringKey: 'product-feature-10000_tokens-description', category: "tokens", description: "10000 tokens monthly" },
    { id: 4, featureKey: "private_use", stringKey: 'product-feature-private_use-description', category: "access", description: "license for private use only" },
    { id: 5, featureKey: "commercial_use",stringKey: 'product-feature-commercial_use-description', category: "access", description: "for commercial & private use" },
    { id: 6, featureKey: "narration", stringKey: 'product-feature-narration-description', category: "functional", description: "script-to-music" },
    { id: 7, featureKey: "faster", stringKey: 'product-feature-faster-description',category: "functional", description: "generate faster" },
    { id: 8, featureKey: "duration",stringKey: 'product-feature-duration-description', category: "functional", description: "longer tracks" },
    { id: 9, featureKey: "advanced",stringKey: 'product-feature-advanced-description', category: "functional", description: "multi-track compositions" },
    { id: 10, featureKey: "saved", stringKey: 'product-feature-saved-description',category: "functional", description: "re-using favourite tracks" },
    { id: 11, featureKey: "10_calls", stringKey: 'product-feature-10_calls-description', category: "limits", description: "10 generations per day" },
    { id: 12, featureKey: "25_calls", stringKey: 'product-feature-25_calls-description', category: "limits", description: "25 generations per day" },
    { id: 13, featureKey: "50_calls", stringKey: 'product-feature-50_calls-description', category: "limits", description: "50 generations per day" }
];

  const onCancel = () => {
    setPageView('main');
  };

const handleProductAction = async (product) => {

		setIsLoading(true);
		const priceId=product.stripePriceId;
		const keyTypeId=product.apiKeyTypeId;
		const productId=product.id;
		  const subscriptionId=userProfile.activeProduct.subscriptionId;
		  if (!subscriptionId || product.tier>userProfile.activeProduct.tier) {
			// New purchase or subscription upgrade
			
			try {
				let url = env.stripeSessionUrl;
			  const response = await fetch(url, {
				method: 'POST',
				headers: {
				  'Authorization': `Bearer ${token}`,
				  'Content-Type': 'application/json',
				},
				body: JSON.stringify({ priceId, productId,keyTypeId, subscriptionId }),
			  });
		
			  const session = await response.json();
			
			  if (session.url) {
				window.location.href=session.url;

			  } else {
				setError(canvaAuthenticated.env.strings['app-error-session-expired'] || 'app-error-session-expired');
			  }
			} catch (error) {
			  setError(`Failed: ${error.message}`);
			} finally {
			 // setLoadingButtons(false); // Clear loading state for all buttons
			}
		  } else {
			// Update existing subscription (downgrade)
			try {
		
				let url = env.stripeDowngradeUrl;
			  const response = await fetch(url, {
				method: 'POST',
				headers: {
				  'Authorization': `Bearer ${token}`,
				  'Content-Type': 'application/json',
				},
				body: JSON.stringify({ priceId, productId,keyTypeId,subscriptionId }),
			  });
		
			  const result = await response.json();
			  if (result.error) {
				setError('Error updating subscription');
			  } else {
				window.close();
			  }
			} catch (error) {
			  	setError(`Failed to downgrade: ${error.message}`);
			} finally {
			 
			} 
		  }
		};

  

  const handleDowngradeConfirmation = (product) => {
    handleProductAction(product);
    setDowngradeFlyout(false);
  };

  const handleDowngradeClick = (product) => {
    // Handle downgrade click (if needed)
  };

  const getButton = (product) => {
  
    // Determine button properties dynamically
    let buttonProps = {
      className: 'rounded-4 product-btn',
      variant: 'primary',
      onClick: () => handleProductAction(product),
      disabled: isLoading || userProfile.activeProduct.expires,
      label: isLoading ?  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : (canvaAuthenticated.env.strings['app-product-list-button-label-upgrade'] || 'app-product-list-button-label-upgrade'),
    };
  
    if (product.id === userProfile.activeProduct.id) {
      buttonProps = {
        ...buttonProps,
        variant: 'primary',
        disabled: true,
        label: (canvaAuthenticated.env.strings['app-product-list-button-label-your-plan'] || 'app-product-list-button-label-your-plan'),
      };
    } else {
      const productTier = parseFloat(product.tier);
      const activeTier = parseFloat(userProfile.activeProduct.tier);
  
      if (productTier < activeTier) {
        buttonProps = {
          ...buttonProps,
          variant: 'tertiary',
          disabled: (productTier==1 && activeTier==1.9),
          onClick: () => setDowngradeFlyout(product),
          label: isLoading ? (canvaAuthenticated.env.strings['app-product-list-button-label-loading'] || 'app-product-list-button-label-loading') : (canvaAuthenticated.env.strings['app-product-list-button-label-downgrade'] || 'app-product-list-button-label-downgrade'),
        };
      }
    }
  
    // Render the button
    return (
      <Button {...buttonProps}>
        {buttonProps.label}
      </Button>
    );
  };

	const parsePrice = (priceString) => {
	  if (!priceString) return NaN;
	  const match = priceString.match(/[\d,.]+/);
	  return match ? parseFloat(match[0].replace(',', '.')) : NaN;
	};

	const getDiscountPercentage = (priceStr, oldPriceStr) => {
	  const price = parsePrice(priceStr);
	  const oldPrice = parsePrice(oldPriceStr);
	  if (isNaN(price) || isNaN(oldPrice) || oldPrice <= price) return null;
	
	  const discount = Math.round(((oldPrice - price) / oldPrice) * 100);
	  return discount;
	};



  const renderContent = () => {
    return (
    	<>
    	{error && <Row className="justify-content-center"><Col md={6}><Alert variant="danger">{error}</Alert></Col></Row>}
    	<div className="product-list-container">
			  <Row
				className="product-row g-3" style={{minWidth: userProfile.products.length*300}}
			  >
				
			  {
			  userProfile.products.map((product, index) => {
				  const discount = getDiscountPercentage(product.price, product.oldPrice);
				  return (
						<Col key={product.id || `product-${index}`} className="product-col">
						  <div className={"product-card d-flex flex-column h-100 border shadow rounded-4 "+(product.tier==1 ? "bg-free":"bg-white")}>
							{/* Badge for active subscription */}
							{userProfile.activeProduct.expires &&
							userProfile.activeProduct.id === product.id ? (
							  <Badge className="bg-warning" tone="info">
								{canvaAuthenticated.env.strings['app-text-subscription-ends'] || 'app-text-subscription-ends'}{" "}{userProfile.activeProduct.expires}
							  </Badge>
							) : null}
							
							{userProfile.pricingTest && product.oldPrice? (
							  <div className="pricing-badge">
								<div className={`discount-badge badge-tier-${product.tier.toString().replace('.', '-')}`}>
								  <span className="discount-number">{discount}%</span> 
								  <span className="discount-label">{canvaAuthenticated.env.strings['app-product-list-discount-label'] || 'off'}</span>
								  {/*
								  <span className="discount-label">
									  {product.tier == 1.9
									? (canvaAuthenticated.env.strings['app-product-list-oneliner-once'] || 'app-product-list-oneliner-once')
									: product.tier == 2
									  ? (canvaAuthenticated.env.strings['app-product-list-oneliner-basic'] || 'app-product-list-oneliner-basic')
									  : product.tier == 3 ? (canvaAuthenticated.env.strings['app-product-list-oneliner-premium'] || 'app-product-list-oneliner-premium') : null}
								  </span>
								  */}
								</div>
							  </div>
							) : null}
		
							
							{/* Product Name */}
							<h5 className="product-name">{productNames.find((p) => p.tier === product.tier)?.name || 'Unknown Product'}</h5>
							
							{userProfile.pricingTest ? (
							  
								  <h3 className="product-oneliner">
									  {product.tier == 1.9
									? (canvaAuthenticated.env.strings['app-product-list-oneliner-once'] || 'app-product-list-oneliner-once')
									: product.tier == 2
									  ? (canvaAuthenticated.env.strings['app-product-list-oneliner-basic'] || 'app-product-list-oneliner-basic')
									  : product.tier == 3 ? (canvaAuthenticated.env.strings['app-product-list-oneliner-premium'] || 'app-product-list-oneliner-premium') : "\u00A0"}
								  </h3>
							) : null}
							
							{/* Product Price and Currency */}
							<div className="product-price">
							<Row className="align-items-baseline justify-content-center text-center flex-nowrap g-0 mt-2 mb-2">
							  <Col className="flex-grow-1 text-end pe-1">
								{userProfile.pricingTest && product.oldPrice && (
								  <span className="old-price">{product.oldPrice}</span>
								)}
							  </Col>
							
							  <Col className="flex-grow-0 text-center">
								<h2 className="fw-semibold mb-0">
								  {product.price === "free"
									? (canvaAuthenticated.env.strings['app-price-free'] || 'app-price-free')
									: product.price}
								  {product.currency ? '\u00A0' + product.currency : ''}
								</h2>
							  </Col>
							
							  <Col className="flex-grow-1">{/* right filler */}</Col>
							</Row>
							
							<div className="mt-n1 small text-center">
							  {product.tier == 1.9
								? (canvaAuthenticated.env.strings['app-product-list-price-once'] || 'app-product-list-price-once')
								: product.tier < 2
								  ? (canvaAuthenticated.env.strings['app-product-list-price-each-month'] || 'app-product-list-price-each-month')
								  : (canvaAuthenticated.env.strings['app-product-list-price-per-month'] || 'app-product-list-price-per-month')}
							</div>
							</div>

						
							{/* Product Features */}
							<div className="product-features flex-grow-1">
							  {product.features.map((feature, featureIndex) => (
								<div key={`feature-${featureIndex}`} className="feature-item">
								  &#9702;{' '}
								  {canvaAuthenticated.env.strings["product-feature-"+feature.featureKey+"-description"] || "product-feature-"+feature.featureKey+"-description"}
								</div>
							  ))}
							</div>
						
							{/* Product Button */}
							<div className="mt-auto">
							  {getButton(product)}
							</div>
						  </div>
						</Col>
			
					  );
					})
				}
			  <DowngradeConfirmationModal
				show={downgradeFlyout}
				product={downgradeFlyout}
				onHide={() => setDowngradeFlyout(false)}
				onConfirm={handleDowngradeConfirmation}
			  />
		  </Row>
		</div>
		</>
    );
  };


  return <>{renderContent()}</>;
};

export default ProductList;
